import { Box, TextInput } from '@mantine/core';
import { IconArrowUp } from '@tabler/icons-react';
import { LexicalEditor } from 'lexical';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SIESTA_SELECTION_REQUEST_COMMAND } from './SiestaInlinePlugin';

type Props = {
  editor: LexicalEditor;
};

export function SiestaInlineInput({ editor }: Props) {
  const [value, setValue] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const borderColor = isFocused ? 'var(--mantine-color-orange-4)' : 'var(--mantine-color-gray-3)';

  const handleSubmit = () => {
    if (value.trim() && !isProcessing) {
      setIsProcessing(true);
      editor.dispatchCommand(SIESTA_SELECTION_REQUEST_COMMAND, { promptText: value });
      setTimeout(() => {
        setValue('');
        setIsProcessing(false);
      }, 500);
    }
  };

  return (
    <TextInput
      value={value}
      onChange={e => setValue(e.currentTarget.value)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onKeyDown={e => {
        if (e.key === 'Enter' && !isProcessing) {
          e.preventDefault();
          handleSubmit();
        }
      }}
      disabled={isProcessing}
      placeholder="Ask Siesta AI to help"
      styles={{
        input: {
          height: 36,
          paddingLeft: 12,
          paddingRight: 8,
          borderRadius: 16,
          border: `1px solid ${borderColor}`,
          backgroundColor: 'white',
          fontSize: 'var(--mantine-font-size-sm)',
          fontWeight: FONT_WEIGHTS.medium,
          color: 'var(--mantine-color-gray-10)',
          '&::placeholder': {
            color: 'var(--mantine-color-gray-3)',
          },
        },
      }}
      rightSection={
        <Box
          onClick={handleSubmit}
          style={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            backgroundColor: borderColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <IconArrowUp size={12} color="white" />
        </Box>
      }
      rightSectionPointerEvents="auto"
    />
  );
}
